import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=c0a6766c"
import script from "./FooterContact.vue?vue&type=script&lang=js"
export * from "./FooterContact.vue?vue&type=script&lang=js"
import style0 from "./FooterContact.vue?vue&type=style&index=0&id=c0a6766c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FooterContact.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports